import { addHours, addMonths, format, subDays } from 'date-fns';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { useState } from 'react';
import { unMask } from 'remask';

import { FaDownload } from 'react-icons/fa';
import { ApiAdimplencia } from '../../../../services/api';
import { ConvertDateDoMounth, formatCurrency } from '../../../../utils/formatCurrency';
import GeraXLSX from '../../../../utils/GeraXLSX';

export default function ExportarParaXLS({ close, data, dataTotal, searchData }) {

    const { credor_id, filterParam = '', selectedFilter, recebivelTipoId, filterTimeStart, filterTimeEnd } = searchData

    const [dataSet, setDataSet] = useState([])
    const [arquivoNome, setArquivoNome] = useState(`relatorio_${selectedFilter}_${format(new Date(), 'dd-MM-yyyy')}`)
    const [arquivoNumero, setArquivoNumero] = useState(dataTotal)

    const [showConfirm, setShowConfirm] = useState(false)

    function formataDataSet(array = data) {
        const arrayFormatado = [];
        array.map(item => {
            arrayFormatado.push({
                boleto_situacao: item.boleto_situacao,
                contrato_numero: item.contratante_numero,
                usuario_nome: item.usuario_nome,
                usuario_documento: item.usuario_documento,
                faturamento_descricao: item.faturamento_descricao,
                rec_contratante_valor: formatCurrency(item.boleto_valor),
                rec_contratante_desconto: formatCurrency(item.faturamento_desconto),
                boleto_vencimento: format(addHours(new Date(item.boleto_vencimento), 3), 'dd/MM/yyyy'),
                boleto_valor_pago: formatCurrency(item.boleto_valor_pago)
            })
        })
        setDataSet(arrayFormatado)
    }

    async function buscaLinhas(numero = dataTotal) {
        if (arquivoNumero) {
            if (arquivoNumero > dataTotal) numero = dataTotal
            else if (arquivoNumero <= 0) numero = 1
            else numero = arquivoNumero
        }

        let arrayResultado = []

        let filtro = ''
        let stringArray = filterParam;
        if (selectedFilter === 'documento') {
            filtro = selectedFilter
            stringArray = unMask(filterParam);
        } else if (selectedFilter !== 'nome') {
            filtro = selectedFilter
            const formatedDate = await ConvertDateDoMounth(filterParam)
            stringArray = formatedDate.split('/');

            if (selectedFilter === 'avulso') {
                filtro = selectedFilter + recebivelTipoId
            }
        }

        const filtroMes = stringArray[0];
        const filtroAno = stringArray[1];

        const dataInteiraInicial = addHours(new Date(filtroAno + '-' + filtroMes + '-01'), 3)
        const dataInteiraFinal = subDays(addMonths(new Date(dataInteiraInicial), 1), 1)

        let queries = [`limit=${numero}`, `page=0`]

        switch (filtro) {
            case 'mesano':
                queries.push(
                    `mes_referencia=${filtroMes}`,
                    `ano_referencia=${filtroAno}`
                );
                break;
            case 'recebivel':
                queries.push(
                    `recebivel_tipo_id=${recebivelTipoId}`,
                    `mes_referencia=${filtroMes}`,
                    `ano_referencia=${filtroAno}`
                );
                break;
            case 'avulsoreferencia':
                queries.push(
                    `recebivel_tipo_id=LANCAMENTO`,
                    `mes_referencia=${filtroMes}`,
                    `ano_referencia=${filtroAno}`
                );
                break;
            case 'avulsovencimento':
                queries.push(
                    `recebivel_tipo_id=LANCAMENTO`,
                    `vencimento_inicio=${dataInteiraInicial.toISOString().split("T")[0]}`,
                    `vencimento_fim=${dataInteiraFinal.toISOString().split("T")[0]}`
                );
                break;
            case 'documento':
                queries.push(`usuario_documento=${stringArray}`);
                break;
            case 'nome':
                queries.push(`usuario_nome=${stringArray}`);
                break;
            case 'beneficiario':
                queries.push(`beneficiario=${stringArray}`);
                break;
            case 'vencimento':
                queries.push(
                    `vencimento_inicio=${filterTimeStart.toISOString().split("T")[0]}`,
                    `vencimento_fim=${filterTimeEnd.toISOString().split("T")[0]}`
                );
                break;
            case 'pagamento':
                queries.push(
                    `pagamento_inicio=${filterTimeStart.toISOString().split("T")[0]}`,
                    `pagamento_fim=${filterTimeEnd.toISOString().split("T")[0]}`
                );
                break;
            case 'repasse':
                queries.push(
                    `repasse_inicio=${filterTimeStart.toISOString().split("T")[0]}`,
                    `repasse_fim=${filterTimeEnd.toISOString().split("T")[0]}`
                );
                break;
            default:
                queries.push('')
        }

        const { data } = await ApiAdimplencia.get(`/boleto?${queries.join('&')}`);
        // console.log('buscaLinhas.data', data)

        arrayResultado = data.results

        formataDataSet(arrayResultado)
    }

    function atualizaEFecha() {
        setDataSet([])
        setArquivoNome('')
        setArquivoNumero('')

        close()
    }

    function handleSubmit(event) {
        event.preventDefault();
        setDataSet([])
        buscaLinhas(arquivoNumero)

        setShowConfirm(true)
    }

    function BaixarXLSX() {
        const headers = [
            'Status',
            'Contrato',
            'Contratante',
            'Documento',
            'Descrição',
            'Valor',
            'Desconto',
            'Vencimento',
            'Valor pago'
        ]
        const fields = [
            "boleto_situacao",
            "contrato_numero",
            "usuario_nome",
            "usuario_documento",
            "faturamento_descricao",
            "rec_contratante_valor",
            "rec_contratante_desconto",
            "boleto_vencimento",
            "boleto_valor_pago"
        ]
        const parametrosXLSX = {
            data: dataSet,
            headers: headers,
            fields: fields,
            titulo: `${arquivoNome}`
        }
        GeraXLSX(parametrosXLSX)
        atualizaEFecha()
    }

    return (
        <Dialog
            visible
            draggable={false}
            header="Por favor digite os parâmetros para exportação em XLS."
            onHide={() => close()}
            pt={{
                root: {
                    className: 'lg:w-4/12 md:w-8/12 w-full overflow-y-scroll'
                }
            }}
        >
            {showConfirm && (
                <Dialog
                    onHide={() => setShowConfirm(false)}
                    header={`Gerando o Arquivo [${arquivoNome}.xls]`}
                    visible
                    draggable={false}
                    pt={{
                        root: {
                            className: 'w-4/12'
                        }
                    }}
                >
                    <div className="w-full flex items-center justify-center mt-3">
                        <div className="w-full mt-2 md:w-2/3 lg:w-1/3">
                            <Button
                                label={dataSet.length ? "Baixar" : "Processando"}
                                loading={dataSet.length ? false : true}
                                severity='success'
                                className='w-full'
                                icon={<FaDownload className='mr-2' />}
                                onClick={() => BaixarXLSX()}
                            />
                        </div>
                    </div>
                </Dialog>
            )}
            <form onSubmit={e => handleSubmit(e)}>
                <div className="flex flex-col p-3">
                    <div className="flex flex-col w-full">
                        <label htmlFor="nome_arquivo_xlsx" className='mt-2 mb-2'>Nome do arquivo</label>
                        <InputText
                            id="nome_arquivo_xlsx"
                            placeholder="ex: boletos2022"
                            value={arquivoNome}
                            onChange={(e) => setArquivoNome(e.target.value)}
                            required
                        />
                    </div>
                    <div className="flex flex-col w-full">
                        <label htmlFor="numero_arquivo_xlsx" className='mt-2 mb-2'>Número de linhas na tabela (total: {dataTotal})</label>
                        <InputText
                            id="numero_arquivo_xlsx"
                            placeholder="ex: 5 linhas"
                            type="number"
                            value={arquivoNumero}
                            onChange={(e) => setArquivoNumero(Number(e.target.value))}
                            required
                        />
                    </div>
                    <div className="w-full flex items-center justify-center mt-3">
                        <div className="w-full mt-2 md:w-2/3 lg:w-1/3">
                            <Button
                                className='w-full'
                                label="Enviar"
                                severity='success'
                            />
                        </div>
                    </div>
                </div>
            </form>
        </Dialog>
    );
}
